import { useContext } from 'react'
import { FlashContext } from 'src/contexts/FlashProvider'

export default function useFlash() {
  return useContext(FlashContext)
}
